<template>
    <div class="questions-sidebar position-sticky">
        <ul class="generic-list-item">
            <li>
                <router-link to="/">
                    <el-icon><HomeFilled /></el-icon> Home
                </router-link>
            </li>
            <li>
                <router-link to="/jobs">
                    <el-icon><Briefcase /></el-icon> Jobs
                </router-link>
            </li>
            <li>
                <router-link to="/badges">
                    <el-icon><Management /></el-icon> Badges
                </router-link>
            </li>
            <li>
                <router-link to="/users">
                    <el-icon><User /></el-icon> Users
                </router-link>
            </li>
            <li>
                <router-link to="/tags">
                    <el-icon><PriceTag /></el-icon> Tags
                </router-link>
            </li>
            <li>
                <router-link to="/category">
                    <el-icon><DataAnalysis /></el-icon> History
                </router-link>
            </li>
            <li>
                <router-link to="/category">
                    <el-icon><Monitor /></el-icon> Technology
                </router-link>
            </li>
            <li>
                <router-link to="/category">
                    <el-icon><ShoppingBag /></el-icon> Business
                </router-link>
            </li>
            <li>
                <router-link to="/category">
                    <el-icon><DocumentCopy /></el-icon> All Topic
                </router-link>
            </li>
            <li>
                <router-link to="/category">
                    <el-icon><Check /></el-icon> Unanswered
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import {
    HomeFilled, 
    Briefcase, 
    Management, 
    DataAnalysis, 
    User, 
    Monitor,
    ShoppingBag, 
    DocumentCopy,
    Check,
    PriceTag,
} from '@element-plus/icons-vue';

export default {
    name: 'QuestionsSidebar',
    components: {
        HomeFilled,
        Briefcase,
        Management,
        DataAnalysis,
        User,
        Monitor,
        ShoppingBag,
        DocumentCopy,
        Check,
        PriceTag,
    },
    data() {
        return {
            
        }
    }
}
</script>